import React, {useState} from "react";
import GoogleAuth from "../components/Auth/GoogleAuth";
import EmailStep from "../components/Auth/EmailStep";
import {Box, Paper, Stack} from "@mui/material";
import medendoLogo from "../assets/medendo_logo.png";

const Login: React.FC = () => {
    const [showGoogleAuth, setShowGoogleAuth] = useState(true);
    const [showEmailStep, setShowEmailStep] = useState(true);

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100vh',
            }}
        >
            <Paper>
                <Stack
                    justifyContent="center"
                    alignItems="stretch"
                    width={400}
                    p={2}
                >
                    <Box sx={{display: 'flex', justifyContent: 'center'}}>
                        <img src={medendoLogo} alt="Logo" width={200}/>
                    </Box>
                    {showEmailStep && <EmailStep onStartEmailAuth={() => setShowGoogleAuth(false)}/>}
                    {showGoogleAuth && <GoogleAuth onMfaRequired={() => setShowEmailStep(false)}/>}
                </Stack>
            </Paper>
        </Box>
    );
};

export default Login;
